import {
	DanThuocItemResponse,
	fa_danthuoc,
	fa_danthuoc_chitiet,
	fa_danthuoc_hinhanh
} from "../../../models/response/y-te/fa_danthuoc";
import {
	eDanThuocActionTypeIds,
	IDanThuocCapNhatXuLyErr,
	IDanThuocCapNhatXuLyPayload,
	IDanThuocCapNhatXuLyStart,
	IDanThuocCapNhatXuLySuccess,
	IDanThuocChangeSelectedId,
	IDanThuocChangeSelectedIds,
	IDanThuocCloseChiTietConfirm,
	IDanThuocCloseChiTietDetail,
	IDanThuocCloseConfirm,
	IDanThuocCloseDetail,
	IDanThuocDeleteChiTietErr,
	IDanThuocDeleteChiTietStart,
	IDanThuocDeleteChiTietSuccess,
	IDanThuocDeleteErr,
	IDanThuocDeleteStart,
	IDanThuocDeleteSuccess,
	IDanThuocLoadChiTietErr,
	IDanThuocLoadChiTietStart,
	IDanThuocLoadChiTietSuccess,
	IDanThuocLoadDetailErr,
	IDanThuocLoadDetailStart,
	IDanThuocLoadDetailSuccess,
	IDanThuocLoadErr,
	IDanThuocLoadHinhAnhErr,
	IDanThuocLoadHinhAnhStart,
	IDanThuocLoadHinhAnhSuccess,
	IDanThuocLoadStart,
	IDanThuocLoadSuccess,
	IDanThuocSaveChiTietErr,
	IDanThuocSaveChiTietStart,
	IDanThuocSaveChiTietSuccess,
	IDanThuocSaveErr,
	IDanThuocSaveStart,
	IDanThuocSaveSuccess,
	IDanThuocShowChiTietConfirm,
	IDanThuocShowChiTietDetail,
	IDanThuocShowConfirm,
	IDanThuocShowDetail
} from "../../action-types/y-te/IDanThuocActionTypes";

export const danThuocActions = {
	loadDanThuocStart: (dm_coso_id: number): IDanThuocLoadStart => {
		return {
			type: eDanThuocActionTypeIds.LOAD_START,
			payload: dm_coso_id
		}
	},
	loadDanThuocSuccess: (data: DanThuocItemResponse[]): IDanThuocLoadSuccess => {
		return {
			type: eDanThuocActionTypeIds.LOAD_SUCCESS,
			payload: data
		}
	},
	loadDanThuocError: (message: string): IDanThuocLoadErr => {
		return {
			type: eDanThuocActionTypeIds.LOAD_ERROR,
			payload: message
		}
	},
	loadDanThuocDetailStart: (id: number): IDanThuocLoadDetailStart => {
		return {
			type: eDanThuocActionTypeIds.LOAD_DETAIL_START,
			payload: id
		}
	},
	loadDanThuocDetailSuccess: (data: DanThuocItemResponse): IDanThuocLoadDetailSuccess => {
		return {
			type: eDanThuocActionTypeIds.LOAD_DETAIL_SUCCESS,
			payload: data
		}
	},
	loadDanThuocDetailError: (message: string): IDanThuocLoadDetailErr => {
		return {
			type: eDanThuocActionTypeIds.LOAD_DETAIL_ERROR,
			payload: message
		}
	},
	showDanThuocDetail: (data?: DanThuocItemResponse): IDanThuocShowDetail => {
		return {
			type: eDanThuocActionTypeIds.SHOW_DETAIL,
			payload: data
		}
	},
	closeDanThuocDetail: (): IDanThuocCloseDetail => {
		return {
			type: eDanThuocActionTypeIds.CLOSE_DETAIL
		}
	},
	changeDanThuocSelectedIds: (ids: number[]): IDanThuocChangeSelectedIds => {
		return {
			type: eDanThuocActionTypeIds.CHANGE_SELECTED_IDS,
			payload: ids
		}
	},
	changeDanThuocSelectedId: (id: number): IDanThuocChangeSelectedId => {
		return {
			type: eDanThuocActionTypeIds.CHANGE_SELECTED_ID,
			payload: id
		}
	},
	showDanThuocConfirm: (data?: DanThuocItemResponse): IDanThuocShowConfirm => {
		return {
			type: eDanThuocActionTypeIds.SHOW_CONFIRM,
			payload: data
		}
	},
	closeDanThuocConfirm: (): IDanThuocCloseConfirm => {
		return {
			type: eDanThuocActionTypeIds.CLOSE_CONFIRM
		}
	},
	saveDanThuocStart: (data: fa_danthuoc): IDanThuocSaveStart => {
		return {
			type: eDanThuocActionTypeIds.SAVE_START,
			payload: data
		}
	},
	saveDanThuocSuccess: (is_update: boolean): IDanThuocSaveSuccess => {
		return {
			type: eDanThuocActionTypeIds.SAVE_SUCCESS,
			payload: is_update
		}
	},
	saveDanThuocError: (message: string): IDanThuocSaveErr => {
		return {
			type: eDanThuocActionTypeIds.SAVE_ERROR,
			payload: message
		}
	},
	deleteDanThuocStart: (id: number): IDanThuocDeleteStart => {
		return {
			type: eDanThuocActionTypeIds.DELETE_START,
			payload: id
		}
	},
	deleteDanThuocSuccess: (): IDanThuocDeleteSuccess => {
		return {
			type: eDanThuocActionTypeIds.DELETE_SUCCESS
		}
	},
	deleteDanThuocError: (message: string): IDanThuocDeleteErr => {
		return {
			type: eDanThuocActionTypeIds.DELETE_ERROR,
			payload: message
		}
	},
	capNhatXuLyDanThuocStart: (payload: IDanThuocCapNhatXuLyPayload): IDanThuocCapNhatXuLyStart => {
		return {
			type: eDanThuocActionTypeIds.CAPNHAT_XULY_START,
			payload: payload
		}
	},
	capNhatXuLyDanThuocSuccess: (): IDanThuocCapNhatXuLySuccess => {
		return {
			type: eDanThuocActionTypeIds.CAPNHAT_XULY_SUCCESS
		}
	},
	capNhatXuLyDanThuocError: (message: string): IDanThuocCapNhatXuLyErr => {
		return {
			type: eDanThuocActionTypeIds.CAPNHAT_XULY_ERROR,
			payload: message
		}
	},
	loadDanThuocChiTietStart: (fa_danthuoc_id: number): IDanThuocLoadChiTietStart => {
		return {
			type: eDanThuocActionTypeIds.LOAD_CHITIET_START,
			payload: fa_danthuoc_id
		}
	},
	loadDanThuocChiTietSuccess: (data: fa_danthuoc_chitiet[]): IDanThuocLoadChiTietSuccess => {
		return {
			type: eDanThuocActionTypeIds.LOAD_CHITIET_SUCCESS,
			payload: data
		}
	},
	loadDanThuocChiTietError: (message: string): IDanThuocLoadChiTietErr => {
		return {
			type: eDanThuocActionTypeIds.LOAD_CHITIET_ERROR,
			payload: message
		}
	},
	showDanThuocChiTietDetail: (data?: fa_danthuoc_chitiet): IDanThuocShowChiTietDetail => {
		return {
			type: eDanThuocActionTypeIds.SHOW_CHITIET_DETAIL,
			payload: data
		}
	},
	closeDanThuocChiTietDetail: (): IDanThuocCloseChiTietDetail => {
		return {
			type: eDanThuocActionTypeIds.CLOSE_CHITIET_DETAIL
		}
	},
	saveDanThuocChiTietStart: (data: fa_danthuoc_chitiet): IDanThuocSaveChiTietStart => {
		return {
			type: eDanThuocActionTypeIds.SAVE_CHITIET_START,
			payload: data
		}
	},
	saveDanThuocChiTietSuccess: (is_update: boolean): IDanThuocSaveChiTietSuccess => {
		return {
			type: eDanThuocActionTypeIds.SAVE_CHITIET_SUCCESS,
			payload: is_update
		}
	},
	saveDanThuocChiTietError: (message: string): IDanThuocSaveChiTietErr => {
		return {
			type: eDanThuocActionTypeIds.SAVE_CHITIET_ERROR,
			payload: message
		}
	},
	showDanThuocChiTietConfirm: (data?: fa_danthuoc_chitiet): IDanThuocShowChiTietConfirm => {
		return {
			type: eDanThuocActionTypeIds.SHOW_CHITIET_CONFIRM,
			payload: data
		}
	},
	closeDanThuocChiTietConfirm: (): IDanThuocCloseChiTietConfirm => {
		return {
			type: eDanThuocActionTypeIds.CLOSE_CHITIET_CONFIRM
		}
	},
	deleteDanThuocChiTietStart: (id: number): IDanThuocDeleteChiTietStart => {
		return {
			type: eDanThuocActionTypeIds.DELETE_CHITIET_START,
			payload: id
		}
	},
	deleteDanThuocChiTietSuccess: (): IDanThuocDeleteChiTietSuccess => {
		return {
			type: eDanThuocActionTypeIds.DELETE_CHITIET_SUCCESS
		}
	},
	deleteDanThuocChiTietError: (message: string): IDanThuocDeleteChiTietErr => {
		return {
			type: eDanThuocActionTypeIds.DELETE_CHITIET_ERROR,
			payload: message
		}
	},
	loadDanThuocHinhAnhStart: (fa_danthuoc_id: number): IDanThuocLoadHinhAnhStart => {
		return {
			type: eDanThuocActionTypeIds.LOAD_HINHANH_START,
			payload: fa_danthuoc_id
		}
	},
	loadDanThuocHinhAnhSuccess: (data: fa_danthuoc_hinhanh[]): IDanThuocLoadHinhAnhSuccess => {
		return {
			type: eDanThuocActionTypeIds.LOAD_HINHANH_SUCCESS,
			payload: data
		}
	},
	loadDanThuocHinhAnhError: (message: string): IDanThuocLoadHinhAnhErr => {
		return {
			type: eDanThuocActionTypeIds.LOAD_HINHANH_ERROR,
			payload: message
		}
	}
}
